export default class EditionPolicy {
    constructor(gate) {
        this.gate = gate;
    }

    browse(user, publication) {
        return this.gate.allow('read', 'publication', publication)
            && user.hasPermissionTo('browse:editions');
    }

    add(user, publication) {
        return this.gate.allow('read', 'publication', publication)
            && user.hasPermissionTo('add:editions');
    }

    edit(user, edition, publication) {
        return edition.deleted_at === null
            && this.gate.allow('read', 'publication', publication)
            && user.hasPermissionTo('edit:editions');
    }

    destroy(user, edition, publication) {
        return edition.deleted_at === null
            && this.gate.allow('edit', 'publication', publication)
            && user.hasPermissionTo('delete:editions');
    }

    restore(user, edition, publication) {
        return edition.deleted_at !== null
            && this.gate.allow('edit', 'publication', publication)
            && user.hasPermissionTo('delete:editions');
    }
}
